import { Skeleton, Stack } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { WorkflowActivity } from "../../../../../api/types/workflowTypes";
import WorkflowActivityExecutionLogsSection from "./WorkflowActivityExecutionLogsSection";

const skeletonRowValueWidths = ["62%", "30%", "38%", "50%"];

const WorkflowActivityDetailSkeleton = () => {
  return (
    <Stack spacing={1} useFlexGap>
      <Skeleton variant="rounded" width="35%" height={16} sx={{ mb: 0.5 }} />
      {skeletonRowValueWidths.map((width, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <Stack key={index} spacing={1} direction="row" sx={{ alignItems: "center" }}>
          <Skeleton variant="rounded" width={200} height={40} />
          <Skeleton variant="rounded" width={width} height={40} />
        </Stack>
      ))}
    </Stack>
  );
};

interface Props {
  activity: WorkflowActivity;
}

const WorkflowExecutingActivityDetailContent = ({ activity }: Props) => {
  return (
    <ScrollableFlexContainer>
      <Stack spacing={1.5} sx={{ px: 3, py: 2.5 }}>
        <WorkflowActivityDetailSkeleton />
        <WorkflowActivityExecutionLogsSection activity={activity} defaultExpanded />
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default WorkflowExecutingActivityDetailContent;
